import { FieldPath, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ControlledRadio } from 'components/ControlledFields'
import { ICustomFieldComponentProps } from 'types'
import { yesNoOptions } from 'consts'

type AmexMarketingMaterialsFieldProps<T extends FieldValues> =
  ICustomFieldComponentProps<T, FieldPath<T>>

export const AmexMarketingMaterialsField = <T extends FieldValues>({
  name,
  label
}: AmexMarketingMaterialsFieldProps<T>) => {
  const { t } = useTranslation('common')

  return (
    <div>
      <ControlledRadio name={name} label={label} options={yesNoOptions} />
      <p className="mt-4 text-xs text-bluePrimary-800">
        {t('businessActivity.fields.wantsAmexMarketingMaterials.info')}
      </p>
    </div>
  )
}
